import { useMutation } from '@tanstack/react-query';
import { types as api } from '@mesa-labs/mesa-api';
import { createVendorApiClient } from '../lib/apiClient';

const vendorApi = createVendorApiClient();

export const useImpersonatePartnerMutation = () =>
  useMutation({
    mutationFn: (partnerId: api.Partners) =>
      vendorApi.impersonatePartner(partnerId),
  });

export const useEndPartnerImpersonationMutation = () =>
  useMutation({
    mutationFn: (partnerId: api.Partners) =>
      vendorApi.endPartnerImpersonation(partnerId),
  });